import {getDataForWorkforceExcelDownload} from "../../Services/workforce";
import {ExcelFileGeneratorUtil} from "../../utils/ExcelUtils/ExcelFileGeneratorUtil";


export const CaseListingExcelDownload = async (data)=> {

    getDataForWorkforceExcelDownload({...data}).then(response => {
        //filter and format the data
        return response?.data?.map(row => {
            return ({
                "ID": row?.id,
                "Case ID": row?.caseIdStr ?? "NA",
                "Case Type": row?.caseType ?? "NA",
                "Alarm Type": row?.alarmType ?? "NA",
                "Created At": row?.createdAt ?? "NA",
                "Created By": row?.createdBy ?? "NA",
                "Case Status": row?.caseStatus ?? "NA",
                "Date of Status Change: Resolved": row?.resolvedDate ?? "NA",
                "Date of Status Change: Completed": row?.completedDate ?? "NA",
                "Date of Status Change: Cancelled": row?.cancelledDate ?? "NA",
                "Region": row?.region ?? "NA",
                "Address": row?.address ?? "NA",
                "Installation Date": row?.installationDate ?? "NA",
                "Assign To": row?.assignTo ?? "NA",
                "Geo Code": row?.geoCode ?? "NA",
                "Before: Old Meter No": row?.before?.oldMeterSerialNo ?? "NA",
                "Before: Meter Manufacturer": row?.before?.oldMeterManufacturer ?? "NA",
                "Before: Final Meter Reading": row?.before?.meterReading ?? "NA",
                "Before: Logger No": row?.before?.oldLoggerSerialNo ?? "NA",
                "Before: Logger Manufacturer": row?.before?.oldLoggerManufacturer?.name ?? "NA",
                "Before: Old Simcard No": row?.before?.oldSimCardSerialNo ?? "NA",
                "Before: Old Simcard Manufacturer": row?.before?.oldSimCardManufacturer?.name ?? "NA",
                "Before: Verificator Reading": row?.before?.verificationReading ?? "NA",
                "Before: Remarks": row?.before?.remarks ?? "NA",
                "After: New Meter No": row?.after?.newMeterSerialNo ?? "NA",
                "After: Meter Manufacturer": row?.after?.newMeterManufacturer?.name ?? "NA",
                "After: New Meter Reading": row?.after?.meterReading ?? "NA",
                "After: Logger No": row?.after?.newLoggerSerialNo ?? "NA",
                "After: Logger Manufacturer": row?.after?.newLoggerManufacturer?.name ?? "NA",
                "After: New Simcard No": row?.after?.newSimCardSerialNo ?? "NA",
                "After: Old Simcard Manufacturer": row?.after?.newSimCardManufacturer?.name ?? "NA",
                "After: Verificator Reading": row?.after?.verificationReading ?? "NA",
                "After: Findings / Result": row?.after?.findings ?? "NA",
                "After: Remarks": row?.after?.remarks ?? "NA",
            });
        });
    }).then(res => {
        ExcelFileGeneratorUtil({
            filename: "workforce-data.xlsx",
            formattedDataForExcelFile: res,
        });
    });
}